import { render, staticRenderFns } from "./listaPerfil.vue?vue&type=template&id=044a564c&scoped=true&"
import script from "./listaPerfil.vue?vue&type=script&lang=js&"
export * from "./listaPerfil.vue?vue&type=script&lang=js&"
import style0 from "./listaPerfil.vue?vue&type=style&index=0&id=044a564c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a564c",
  null
  
)

export default component.exports